import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-error-dialog',
    templateUrl: './error-dialog.component.html',
    styleUrls: ['./error-dialog.component.css']
})
export class ErrorDialogComponent implements OnInit {

    @Input() title: string;
    @Input() modalId: string;
    @Input() messageA: string;
    @Input() messageB: string;
    @Input() messageC: string;
    @Input() dialogClass: string;
    @Input() messageAClass: string;
    @Input() messageBClass: string;
    @Input() messageCClass: string;
    @Output() closeModal = new EventEmitter<void>();

    constructor() { }

    ngOnInit() {
    }

    onCloseModal() {
        if (this.closeModal) {
            this.closeModal.emit();
        }
    }

}
